import { IconButton, Tooltip } from "@chakra-ui/react"
import { ArrowsClockwise } from "@phosphor-icons/react"
import Button from "components/common/Button"
import useSWRWithOptionalAuth from "hooks/useSWRWithOptionalAuth"
import useShowErrorToast from "hooks/useShowErrorToast"
import { useRouter } from "next/router"
import { useState } from "react"
import useGuild from "../hooks/useGuild"
import usePointsLeaderboard, {
  PointsLeaderboardResponse,
} from "./hooks/usePointsLeaderboard"

type Props = {
  size?: "FULL" | "ICON"
}

const RecalculateLeaderboardButton = ({ size = "FULL" }: Props) => {
  const { id: guildId } = useGuild()
  const { query } = useRouter()

  const [shouldRecalculate, setShouldRecalculate] = useState(false)

  const { mutate: mutateCachedLeaderboard } = usePointsLeaderboard()
  const showErrorToast = useShowErrorToast()
  const { mutate: recalculateLeaderboard, isValidating } =
    useSWRWithOptionalAuth<PointsLeaderboardResponse>(
      shouldRecalculate
        ? `/v2/guilds/${guildId}/points/${query.pointsId}/leaderboard?forceRecalculate=true`
        : null,
      {
        onError: (error: any) => {
          showErrorToast(error)
        },
        onSuccess: (newData: PointsLeaderboardResponse) => {
          mutateCachedLeaderboard(() => newData, { revalidate: false })
        },
      },
      false
    )

  const onClick = () => {
    if (shouldRecalculate) recalculateLeaderboard()
    else setShouldRecalculate(true)
  }

  return size === "ICON" ? (
    <Tooltip
      label={isValidating ? "Refreshing..." : "Refresh leaderboard"}
      placement="top"
      hasArrow
    >
      <IconButton
        rounded="none"
        size="sm"
        aria-label="Refresh leaderboard"
        icon={<ArrowsClockwise />}
        onClick={onClick}
        isLoading={isValidating}
      />
    </Tooltip>
  ) : (
    <Button
      size="sm"
      leftIcon={<ArrowsClockwise />}
      onClick={onClick}
      isLoading={isValidating}
      loadingText="Refreshing"
    >
      Refresh
    </Button>
  )
}
export default RecalculateLeaderboardButton
